export var FrameOutMessageType;
(function (FrameOutMessageType) {
    FrameOutMessageType["callAction"] = "call_action";
})(FrameOutMessageType || (FrameOutMessageType = {}));
export var FrameMessageType;
(function (FrameMessageType) {
    FrameMessageType["success"] = "success";
    FrameMessageType["error"] = "error";
    FrameMessageType["abort"] = "abort";
    FrameMessageType["resize"] = "resize";
    FrameMessageType["discount"] = "discount";
    FrameMessageType["formReady"] = "form-ready";
    FrameMessageType["formStatus"] = "form-status";
    FrameMessageType["formSubmit"] = "form-submit";
    FrameMessageType["authStart"] = "auth-start";
    FrameMessageType["authEnd"] = "auth-end";
    FrameMessageType["authV2Start"] = "auth-v2-start";
    FrameMessageType["authV2End"] = "auth-v2-end";
    FrameMessageType["challengeV2Start"] = "challenge-v2-start";
    FrameMessageType["challengeV2End"] = "challenge-v2-end";
    FrameMessageType["tdsStatus"] = "3ds-status";
    FrameMessageType["tdsStarted"] = "3ds-started";
    FrameMessageType["tdsSuccess"] = "3ds-success";
    FrameMessageType["tdsFailure"] = "3ds-failure";
    FrameMessageType["initCheckout"] = "init-checkout";
    FrameMessageType["formInit"] = "form-init";
    FrameMessageType["paymentComplete"] = "payment-complete";
    FrameMessageType["paymentFail"] = "payment-fail";
    FrameMessageType["paymentTimeout"] = "payment-timeout";
    FrameMessageType["paymentCancel"] = "payment-cancel";
    FrameMessageType["paymentPreview"] = "payment-preview";
    FrameMessageType["paymentLoaded"] = "payment-loaded";
    FrameMessageType["sbpBankSelected"] = "sbp-bank-selected";
    FrameMessageType["sbpStart"] = "sbp-start";
    FrameMessageType["onResize"] = "on_resize";
    FrameMessageType["callActionResponse"] = "call_action_response";
    FrameMessageType["trustChallengeStart"] = "trust-challenge-start";
    FrameMessageType["trustChallengeEnd"] = "trust-challenge-end";
    FrameMessageType["reload"] = "reload";
})(FrameMessageType || (FrameMessageType = {}));
export var FrameMessageAbortReason;
(function (FrameMessageAbortReason) {
    FrameMessageAbortReason["user"] = "user";
    FrameMessageAbortReason["timeout"] = "timeout";
})(FrameMessageAbortReason || (FrameMessageAbortReason = {}));
export var FrameApplePayIncomingMessageType;
(function (FrameApplePayIncomingMessageType) {
    FrameApplePayIncomingMessageType["start"] = "start_apple_pay";
})(FrameApplePayIncomingMessageType || (FrameApplePayIncomingMessageType = {}));
export var FrameApplePayOutgoingMessageType;
(function (FrameApplePayOutgoingMessageType) {
    FrameApplePayOutgoingMessageType["success"] = "apple_pay_success";
    FrameApplePayOutgoingMessageType["failure"] = "apple_pay_failure";
    FrameApplePayOutgoingMessageType["cancel"] = "apple_pay_cancel";
})(FrameApplePayOutgoingMessageType || (FrameApplePayOutgoingMessageType = {}));
